module.exports = __webpack_public_path__ + "img/robot.1d54c9f5.jpg";